export const MAX_BYTE_SIZE = 5000000; // 5 MB

export const imageKeysFilter = (key) => key?.startsWith?.('image');
